import { Directive, ElementRef, Renderer2 } from '@angular/core';

import { environment } from 'src/environments/environment';

// @see https://medium.com/agilix/angular-and-cypress-data-cy-attributes-d698c01df062

@Directive({
  selector: '[data-test]',
})
export class AppDataTestDirective {
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {
    if (!environment.e2e.enable) {
      renderer.removeAttribute(el.nativeElement, 'data-test');
    }
  }
}
